// extracted by mini-css-extract-plugin
export default {"close":"modal-module--close--G1yC4"};